import { Component, Output, EventEmitter, Input } from '@angular/core';
import * as $ from 'jquery';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
  @Input() showToggle = true;
  @Input() showUser = true;
  @Input() showHeader = true;
  @Input() toggleChecked = false;

  @Output() toggleCollapsed = new EventEmitter<void>();

  constructor() { }


  showHideLoader(flag) {
    // if (flag) {
    //   $("#loaderId").addClass("active");
    // } else {
    //   $("#loaderId").removeClass("active");
    // }
  }

  blockScreen(flag) {
    if (flag) {
      $("#blockId").addClass("active");
    } else {
      $("#blockId").removeClass("active");
    }
  }
}
